import React, { useState } from 'react';
import { PortfolioData } from '../types/portfolio';

interface SkillsProps {
  data: PortfolioData;
}

const Skills: React.FC<SkillsProps> = ({ data }) => {
  const [activeCategory, setActiveCategory] = useState<string>(data.skills[0]?.category || '');

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-16">
          <h2 className="text-4xl font-manrope font-bold text-navy mb-4">
            Skills & Expertise
          </h2>
          <div className="h-1 w-16 bg-teal rounded-full"></div>
        </div>

        {/* Category Navigation */}
        <div className="flex flex-wrap gap-4 mb-12 pb-8 border-b border-gray-200">
          {data.skills.map((skill) => (
            <button
              key={skill.category}
              onClick={() => setActiveCategory(skill.category)}
              className={`px-6 py-2 rounded-full font-semibold transition-all duration-300 whitespace-nowrap ${
                activeCategory === skill.category
                  ? 'bg-teal text-white'
                  : 'bg-gray-100 text-navy hover:bg-gray-200'
              }`}
            >
              {skill.category}
            </button>
          ))}
        </div>

        {/* Skills Grid */}
        {data.skills.map((skill) => (
          activeCategory === skill.category && (
            <div
              key={skill.category}
              className="animate-fadeInUp"
            >
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {skill.items.map((item, idx) => (
                  <div
                    key={idx}
                    className="group p-4 bg-gray-50 rounded-lg border border-gray-200 hover:border-teal hover:bg-white transition-all duration-300 hover:shadow-md"
                    style={{ animationDelay: `${idx * 0.05}s` }}
                  >
                    <div className="flex items-start gap-3">
                      <span className="inline-block w-1.5 h-1.5 bg-teal rounded-full mt-2 flex-shrink-0 group-hover:bg-gold transition-colors"></span>
                      <p className="text-navy font-semibold group-hover:text-teal transition-colors">
                        {item}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Category Description */}
              <div className="mt-12 p-6 bg-gradient-to-r from-teal/5 to-gold/5 rounded-xl border border-teal/10">
                <p className="text-slate leading-relaxed text-sm">
                  {skill.category === 'Business Analysis' &&
                    'Core competencies in understanding business needs, mapping processes, analyzing requirements, and defining key performance indicators to drive organizational improvements.'}
                  {skill.category === 'Requirements & Agile Delivery' &&
                    'Expertise in translating business needs into structured documentation and delivering solutions through Agile methodologies with emphasis on quality and continuous improvement.'}
                  {skill.category === 'Data & Reporting' &&
                    'Advanced proficiency in data tools and business intelligence platforms to create dashboards, perform analysis, and provide actionable insights for decision-making.'}
                  {skill.category === 'Tools' &&
                    'Hands-on experience with enterprise and collaboration platforms including ServiceNow, JIRA, and Microsoft suite, enabling efficient workflow management and team coordination.'}
                  {skill.category === 'Delivery & ITSM' &&
                    'Knowledge of IT Service Management frameworks, incident management, and Agile principles to ensure service quality, stakeholder satisfaction, and operational excellence.'}
                </p>
              </div>
            </div>
          )
        ))}
      </div>
    </section>
  );
};

export default Skills;
